module.exports = __webpack_public_path__ + "img/espartanas.07c66c4f.png";